import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { T } from "@/constants/testIds";

const STATUSES = ["draft", "in_review", "theological_review", "approved", "scheduled", "published"];
const LABEL = {
  draft: "Draft",
  in_review: "In review",
  theological_review: "Theol. review",
  approved: "Approved",
  scheduled: "Scheduled",
  published: "Published",
};

export default function CMSArticlesList() {
  const [items, setItems] = useState([]);
  const [sp, setSp] = useSearchParams();
  const status = sp.get("status");

  useEffect(() => {
    const url = status ? `/cms/articles?status=${status}` : `/cms/articles`;
    api.get(url).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [status]);

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="heading-2">Articles</h1>
          <p className="text-sm text-ink-muted mt-1">Every article passes through draft, review, and approval before publication.</p>
        </div>
        <Link to="/cms/articles/new" className="btn-primary" data-testid={T.cmsNewArticleBtn}>
          New Article
        </Link>
      </div>

      <div className="mb-6 flex flex-wrap gap-2">
        <button
          onClick={() => setSp({})}
          className={`px-3 py-1.5 text-xs uppercase tracking-widest border ${!status ? "bg-ink text-background border-ink" : "border-border text-ink-muted"}`}
        >
          All
        </button>
        {STATUSES.map((s) => (
          <button
            key={s}
            onClick={() => setSp({ status: s })}
            className={`px-3 py-1.5 text-xs uppercase tracking-widest border ${
              status === s ? "bg-ink text-background border-ink" : "border-border text-ink-muted hover:border-ink"
            }`}
          >
            {LABEL[s]}
          </button>
        ))}
      </div>

      <div className="paper-card overflow-x-auto">
        <table data-testid={T.cmsArticlesTable} className="w-full text-sm">
          <thead className="bg-subtle text-left">
            <tr>
              <th className="px-4 py-3 eyebrow">Title</th>
              <th className="px-4 py-3 eyebrow">Author</th>
              <th className="px-4 py-3 eyebrow">Category</th>
              <th className="px-4 py-3 eyebrow">Status</th>
              <th className="px-4 py-3 eyebrow">Updated</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr
                key={a.id}
                data-testid={T.cmsArticleRow(a.id)}
                className="border-t border-border hover:bg-subtle"
              >
                <td className="px-4 py-3">
                  <Link to={`/cms/articles/${a.id}`} className="text-ink hover:text-forest">
                    {a.title || <em className="text-ink-muted">Untitled</em>}
                  </Link>
                </td>
                <td className="px-4 py-3 text-ink-muted">{a.author_name}</td>
                <td className="px-4 py-3 text-ink-muted">{a.category}</td>
                <td className="px-4 py-3">
                  <span className="inline-block px-2 py-0.5 text-[10px] uppercase tracking-widest bg-subtle border border-border">
                    {LABEL[a.status] || a.status}
                  </span>
                </td>
                <td className="px-4 py-3 text-ink-muted">{new Date(a.updated_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr>
                <td colSpan={5} className="px-4 py-6 text-center text-ink-muted">No articles.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
